export default {
  initialUserData() {
    return {
      username: null,
      password: null,
      role: '',
      profile: {
        mobile: null,
        name: null,
        nickname: null,
      },
      pt: {
        general: 0,
      },
      source: '',
      type: '',
      url: '',
      currency: '',
      userPermission: {
        member: 'off',
        report: 'off',
        statement: 'off',
        seamless: 'off',
        useronline: 'off',
        suggestion: 'off',
        apikey: 'off',
        reportMechanic: 'off',
      },
      permission: {
        isRefillCredit: false,
        isDeductCredit: false,
        fullMemberAccess: false,
        viewMemberAccess: false,
        reportAccess: false,
        reportMechanic: false,
      },
      websiteUrl: '',
      ipWhitelist: [],
      isFeature: true,
      isCrypto: false,
      isMechanic: false,
    };
  },
  UserType: [
    {
      text: 'AGENT',
      value: 'AGENT',
    },
    {
      text: 'MEMBER',
      value: 'MEMBER',
    },
    {
      text: 'SUBACCOUNT',
      value: 'SUBACCOUNT',
    },
  ],
};
